<section>
  <div class="block-frame pad0">
    <div class="row">
      <div class="col-sm-12">
        <detailed-assignment-location
          [origin]="assignment.origin"
          [destination]="assignment.destination"
        ></detailed-assignment-location>
      </div>
    </div>

    @if (assignment.type_id != 1894) {
    <div class="row details">
      <div class="col-sm-6">
        <dl class="assignment-dates inline">
          <dt>Start date:</dt>
          <dd>
            <date [iso]="assignment.start_date"></date>
            (<relative-time [iso]="assignment.start_date"></relative-time>)
          </dd>
          @if (assignment.end_date) {
          <dt>End date:</dt>
          } @if (assignment.end_date) {
          <dd>
            <date [iso]="assignment.end_date"></date>
            (<relative-time [iso]="assignment.end_date"></relative-time>)
          </dd>
          }
        </dl>
      </div>
      <div class="col-sm-6">
        <dl>
          <dt>Package:</dt>
          @if (assignment?.package?.id) {
          <dd>{{ assignment.package.name }}</dd>
          } @if (!assignment?.package?.id) {
          <dd>
            <empty>No package selected</empty>
          </dd>
          }
          <dt>Type:</dt>
          <dd>{{ assignment.type }}</dd>
        </dl>
      </div>
    </div>
    } @if (assignment.notes) {
    <section class="notes" outline>
      <h2>Notes</h2>
      <p
        class="show-trimmed"
        data-limit="300"
        [innerHTML]="assignment.notes | safeHtml"
        style="white-space: pre-line"
      ></p>
    </section>
    }

    <section class="movetrack">
      <h2>MoveTrack Integration</h2>
      <dl>
        <dd>
          Sent To MoveTrack: {{assignment.is_sent_to_movetrack ? `yes` : `no`}}
        </dd>
        @if (assignment.can_it_be_synced_with_movetrack) {
        <dd>
          <button class="btn btn-default" (click)="syncWithMoveTrack()">
            Sync with MoveTrack
          </button>
        </dd>
        } @if (!assignment.can_it_be_synced_with_movetrack) {
        <dd>
          <empty>Assignment cannot be synced with MoveTrack.</empty>
        </dd>
        }
      </dl>
    </section>
  </div>
</section>
